import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { modalClose, modalAlertaInfo, modalAlertaClean } from '../../layout/redux/layoutActions'
import { listarDashboards, deletarDashboard } from './redux/dashboardActions'
import { Modal, Button, Select, AddAlert } from '../../components' // ✅ IMPORTE AddAlert
import './listar.scss'


const Listar = () => {
  const dispatch = useDispatch()
  const layoutState = useSelector(state => state.layoutState)
  const { sistema, statusModal, usuario } = layoutState
  
  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)

  const [dashboards, setDashboards] = useState([])
  const [dashboardSelecionado, setDashboardSelecionado] = useState(null)
  const [loading, setLoading] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [comboValue, setComboValue] = useState('')
  const [error, setError] = useState(null)


  // ✅ DEBUG: montar/desmontar do componente
  useEffect(() => {
    console.log('[Listar] MOUNT')
    return () => console.log('[Listar] UNMOUNT')
  }, [])

  // ✅ DEBUG: observar mudanças do statusModal
  useEffect(() => {
    console.log('[Listar] statusModal =', statusModal)
  }, [statusModal])

console.log("nada")



  useEffect(() => {
    if (statusModal === 'listar') {
      carregarDashboards()
    }
  }, [statusModal])

  const carregarDashboards = async () => {
    setLoading(true)
    setDashboards([])
    setDashboardSelecionado(null)
    setComboValue('')
    setError(null)

    try {
      const lista = await dispatch(listarDashboards())
      setDashboards(lista || [])
      
      if (lista && lista.length > 0) {
        setDashboardSelecionado(lista[0])
        setComboValue(lista[0])
      }
      
    } catch (error) {
      //console.error('Erro ao carregar dashboards:', error)
      handleClose()
      dispatch(
      modalAlertaInfo({
        ...nlsPopup['152'],
        show: true,
        btnAction: () => {
          dispatch(modalAlertaClean())
        }
      })
    )
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    dispatch(modalClose())
  }

  const handleComboChange = (e) => {
    const selectedDashboard = e.value
    setComboValue(selectedDashboard)
    setDashboardSelecionado(selectedDashboard)
  }

  // ✅ FUNÇÃO CORRIGIDA: Deletar dashboard com AddAlert
  const handleDeletarDashboard = async () => {
    if (!dashboardSelecionado) return

    setDeleting(true)
    
    try {
      await dispatch(deletarDashboard(dashboardSelecionado.id))
      
      // ✅ RECARREGA A LISTA APÓS DELETAR
      await carregarDashboards()
      
      // ✅ MOSTRA ALERTA DE SUCESSO (que desaparece)
      dispatch(AddAlert('success', nls.sucessodeletardash || 'Dashboard deletado com sucesso!'))
      
    } catch (error) {
      console.error('Erro ao deletar dashboard:', error)
      
      // ✅ MOSTRA ALERTA DE ERRO (que desaparece)
      dispatch(AddAlert('danger', nls.problemadeletardash || 'Erro ao deletar dashboard!'))
    } finally {
      setDeleting(false)
    }
  }

  const gerarLinkDashboard = (dashboardId) => {
  const publicDomain = process.env.REACT_APP_PUBLIC_DASHBOARD_DOMAIN || window.location.origin;
  return `${publicDomain}/d/${dashboardId}`;
}

  const formatarLink = (dashboardId) => {
    const url = gerarLinkDashboard(dashboardId)
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #007bff; text-decoration: underline; word-break: break-all;">${url}</a>`
  }

  const contentForm = () => (
    <div className="modal-listar-dashboards">
      <div className="combo-section">
        <div className="combo-container">
          <Select 
            name='dashboardSelect'
            label={nls.listar?.selecioneDashboard || "Selecione um dashboard"}
            options={dashboards}
            selected={comboValue}
            action={handleComboChange}
            selectedItem={false}
            optionLabel='titulo'
            optionValue='id'
            disabled={loading || dashboards.length === 0}

            textCustom={{
              selecione: nls?.select?.selecione || nls?.common?.selecione || (sistema.idioma === 'en-US' ? 'Select' : sistema.idioma === 'esp' ? 'Selecciona' : 'Selecione'),
              selecionado: nls?.select?.selecionado || (sistema.idioma === 'en-US' ? 'Selected' : sistema.idioma === 'esp' ? 'Seleccionado' : 'Selecionado'),
              selecionados: nls?.select?.selecionados || (sistema.idioma === 'en-US' ? 'Selected' : sistema.idioma === 'esp' ? 'Seleccionados' : 'Selecionados'),
              todos: nls?.select?.todos || (sistema.idioma === 'en-US' ? 'Select all' : sistema.idioma === 'esp' ? 'Seleccionar todos' : 'Marcar todos')
            }}


          />
        </div>
        
        {loading && (
          <div className="loading-message">
            {nls.listar?.carregando || "Carregando dashboards..."}
          </div>
        )}
        
        {!loading && dashboards.length === 0 && !error && (
          <div className="empty-message">
            {nls.listar?.nenhumDashboard || "Nenhum dashboard encontrado."}
          </div>
        )}
        
        {error && (
          <div className="error-message">
            {nls.listar?.erroCarregamento || "Erro ao carregar dashboards"}
          </div>
        )}
      </div>

      {/* Informações do Dashboard Selecionado */}
      {dashboardSelecionado && (
        <div className="info-section">
          <h3 className="info-title">
            {nls.listar?.informacoesDashboard || "Informações do Dashboard"}
          </h3>
          
          <div className="info-grid">
            {/* URL do Dashboard */}
            <div className="info-row">
              <label className="info-label">
                {nls.listar?.urlDashboard || "URL do Dashboard"}:
              </label>
              <div 
                className="info-value url-value"
                dangerouslySetInnerHTML={{ 
                  __html: formatarLink(dashboardSelecionado.id) 
                }}
              />
            </div>

            {/* Autor */}
            <div className="info-row">
              <label className="info-label">
                {nls.autor || "Autor"}:
              </label>
              <div className="info-value">
                {dashboardSelecionado.autor}
              </div>
            </div>

            {/* Período Analisado */}
            <div className="info-row">
              <label className="info-label">
                {nls.periodoanalisado || "Período Analisado"}:
              </label>
              <div className="info-value">
                {dashboardSelecionado.periodoAnalisado}
              </div>
            </div>
          </div>

          {/* ✅ BOTÃO DELETAR */}
          <div className="delete-section">
            <Button
              color='error'
              onClick={handleDeletarDashboard}
              disabled={deleting || !dashboardSelecionado}
            >
              {deleting ? (nls.listar?.deletando || 'Deletando...') : (nls.deletar || 'Deletar')}
            </Button>
          </div>
        </div>
      )}
    </div>
  )

  return (
    <Modal
      title={nls.listar?.tituloModal || "Meus Dashboards"}
      size='medium'
      open={statusModal === 'listar'}
      close={handleClose}
      closeText={nls.listar?.btnFechar || "Fechar"}
      actions={
        <>
          <Button
            color='default'
            onClick={handleClose}
          >
            {nls.listar?.btnFechar || "Fechar"}
          </Button>
        </>
      }
    >
      {contentForm()}
    </Modal>
  )
}

export default Listar